/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AccountsandFinanceurl } from "../../../../config";
import { bankAccountFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { allBanks } from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;

const BankAccountForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  const [bankData, setBankData] = useState([]);

  const [loading, setLoading] = useState(true);

  const initialValues = {
    id: props.data ? props.data.id : "",
    bankId: props.data ? props.data.bankId : "",
    accountName: props.data ? props.data.accountName : "",
    accountNumber: props.data ? props.data.accountNumber : "",
    accountDescription: props.data ? props.data.accountDescription : "",
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const bankDataResponse = await graphqlQuery(allBanks, base_url);
        if (bankDataResponse) {
          setBankData(bankDataResponse);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        id,
        bankId,
        accountName,
        accountNumber,
        accountDescription,
      } = values;

      const mutationData = props.isEditing
        ? {
          id,
          bankId,
          accountName,
          accountNumber,
          accountDescription,
          updatedBy: userId,
          company: String(companyId),
        }
        : {
          bankId,
          accountName,
          accountNumber,
          accountDescription,
          createdBy: userId,
          company: String(companyId),
        };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateBankAccount" : "createBankAccount",
        mutationData,
        props.isEditing ? "updatedBankAccount" : "newBankAccount",
        base_url
      );

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Bank account ${props.isEditing ? "updated" : "created"
            } successfully.`,
        });
        if (props.onAction) {
          props.onAction();
        }
        props.onClose(); // Close the drawer
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  if (loading) {
    return <CircularProgress />;
  }

  const bankOptions = bankData ? bankData.map((bank) => ({
    value: bank.id,
    label: bank.bankName,
  })) : [];

  const fields = [
    ...bankAccountFields,
    {
      name: "bankId",
      label: "Bank",
      type: "select",
      options: bankOptions,
      gridColumn: "span 2",
      required: true,
    },
  ];

  // Define steps for the form - all fields in one step
  const steps = [
    {
      stepLabel: "Bank Account Details",
      fields: fields.map(field => field.name),
    }
  ];

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      steps={steps}

      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Bank Account" : "Create Bank Account"}
      subtitle={
        props.isEditing
          ? "Edit an Existing Bank Account"
          : "Create a New Bank Account"
      }
    />
  );
};

export default BankAccountForm;
